import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
import { useVideoTime } from "../../../VideoContextProvider/context/state/time.js";
import { useVideoController } from "../../../VideoContextProvider/context/videoController.js";
import { useIsVideoPaused } from "../../../VideoContextProvider/context/state/isPaused.js";
import { Slider } from "../Slider/index.js";
function Scrubber() {
  const { t } = useTranslation();
  const videoController = useVideoController();
  const isPaused = useIsVideoPaused();
  const { isAtLiveEdge, position, seekableRange } = useVideoTime();
  const { end, start } = seekableRange;
  const [inputValue, setInputValue] = useState(0);
  const handleChange = ({ target }) => {
    const rangeValue = target.valueAsNumber;
    setInputValue(rangeValue);
    videoController.seekTo(rangeValue);
  };
  useEffect(() => {
    if (isAtLiveEdge && !isPaused) {
      setInputValue(end);
    }
    if (!isAtLiveEdge && !isPaused) {
      setInputValue(position + 1);
    }
    if (isAtLiveEdge && isPaused) {
      setInputValue(position);
    }
    if (start > position) {
      setInputValue(start + 3);
    }
  }, [end, isAtLiveEdge, isPaused, position, start]);
  return /* @__PURE__ */ jsx(
    Slider,
    {
      ariaLabel: t("Video Scrubber"),
      className: "omega_slider-scrubber",
      max: end,
      min: start + 3,
      onChange: handleChange,
      value: inputValue || end,
      testId: "video-scrubber"
    }
  );
}
export {
  Scrubber
};
//# sourceMappingURL=index.js.map
